export default __webpack_public_path__ + "static/media/suggest.5193a30a.svg";